export const mockLocationsHeader = {
  label: "Branch locator",
  heading: "Welcome to Willscot",
  subheading: "North America's leader of turnkey modular space and storage solutions.",
};

export const mockLocationsIndexHeaderEN = {
  label: "locations",
  heading: "Find Your Nearest WillScot Location",
  subheading: "North America’s leader of turnkey modular space and storage solutions.",
};

export const mockLocationsIndexHeaderFR = {
  label: "Emplacements",
  heading: "Trouvez votre emplacement WillScot le plus proche",
  subheading: "Leader en Amérique du Nord des solutions modulaires clés en main pour l'espace et le stockage.",
};
